import(/* webpackMode: "eager" */ "/app/src/app/finance/investments/page.tsx");
